import { lazy } from 'react'

// Po wdrożeniu nowej wersji aplikacji stare chunki znikają z serwera - użytkownik
// z otwartą starą kartą dostałby ChunkLoadError przy nawigacji. Jednorazowy reload
// pobiera aktualną wersję aplikacji (flaga w sessionStorage chroni przed pętlą reloadów).
const lazyWithReload = (importFunction) => {
    return lazy(() =>
        importFunction()
            .then(module => {
                sessionStorage.removeItem('chunkReloadedAfterError')
                return module
            })
            .catch(error => {
                if (!sessionStorage.getItem('chunkReloadedAfterError')) {
                    sessionStorage.setItem('chunkReloadedAfterError', 'true')
                    window.location.reload()
                }
                throw error
            })
    )
}

export default lazyWithReload
